var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6233 0.249763C19.2821 -0.0390705 18.7454 -0.0800075 18.195 0.140597C17.6128 0.368025 1.70196 7.19086 1.05379 7.47969C0.935525 7.52063 -0.0833511 7.90271 0.0121685 8.75784C0.107688 9.52882 0.935525 9.84949 1.03559 9.89498L5.08153 11.28C5.34535 12.1647 6.33466 15.4647 6.55299 16.1652C6.68945 16.6041 6.91233 17.1795 7.30123 17.3023C7.45379 17.357 7.61799 17.3708 7.77755 17.3425C7.93711 17.3142 8.08651 17.2447 8.21094 17.1408L10.6763 14.8438L14.6699 17.9664L14.7631 18.0232C15.0077 18.1371 15.2735 18.1983 15.5432 18.2029C15.7318 18.2031 15.9187 18.1668 16.0936 18.096C16.4826 17.9233 16.7909 17.6084 16.9555 17.2159L19.9371 1.7053C20.1191 0.877464 19.8666 0.454448 19.6233 0.249763ZM8.64305 11.8258L7.27849 15.4647L5.91392 10.9161L16.3756 3.18358L8.64305 11.8258Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterShare);
export default __webpack_public_path__ + "static/media/footer-share.5f3bdf6a5fbaf7d5183a6d137986e664.svg";
export { ForwardRef as ReactComponent };